import React, { ChangeEvent, useContext, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import '../styles/css/common.css'
import { useNavigate } from 'react-router-dom'
import { CommonContext } from '../component/common/context/commonContext'
import axios from 'axios'
import { onKeyDownCheckEnter } from '../utils/inputText'
import { getBrand } from '../utils/tenant'
import { Image } from 'primereact/image'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

function Login() {
    const { $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [loginId, setLoginId] = useState<string>('')
    const [pass, setPass] = useState<string>('')
    const [rememberMe, setRememberMe] = useState(false)
    const isProd = process.env.REACT_APP_NODE_ENV === 'prod'
    const brand = getBrand()

    const textStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        fontSize: '40px',
        color: 'yellow',
    }

    const onChangeLoginId = (event: ChangeEvent<HTMLInputElement>) => {
        setLoginId(event.currentTarget.value)
    }

    const onChangePass = (event: ChangeEvent<HTMLInputElement>) => {
        setPass(event.currentTarget.value)
    }
    const onClickLogin = async () => {
        if (!loginId) {
            $alert({
                title: t(tokens.common.fail),
                text: t(tokens.common.please_enter_id),
                icon: 'warn',
            })
            return
        }

        if (!pass) {
            $alert({
                title: t(tokens.common.fail),
                text: t(tokens.common.please_enter_password),
                icon: 'warn',
            })
            return
        }

        const { data: myIp } = await axios.get('https://api64.ipify.org?format=json')
        const { data } = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/login`,
            { loginId, pass },
            {
                headers: {
                    'client-ip': myIp['ip'],
                },
            },
        )
        const { status, error, data: res } = data

        if (status === 401) {
            $alert({
                title: t(tokens.common.fail),
                text: error,
                icon: 'warn',
            })
        } else if (status === 200) {
            const { token } = res
            localStorage.setItem('rdmsToken', `Bearer ${token}`)
            localStorage.setItem('rdmsMyIp', myIp['ip'])
            navigate('/')
        }
    }

    return (
        <>
            <div className="px-5 min-h-screen flex justify-content-center align-items-center rdms-bg-indigo" style={{ height: '100%' }}>
                <div className={'login-background py-7 px-5 md:px-5 z-1 scalein animation-duration-500 w-full'}>
                    <div className="col-12 flex justify-content-center align-content-center">
                        {isProd ? (
                            brand.logoImg ? (
                                <Image src={brand.logoImg} width="250" className="mt-5" />
                            ) : (
                                <div className="text-white font-bold text-4xl mt-5">{brand.logoText}</div>
                            )
                        ) : (
                            <span style={textStyle}> {process.env.REACT_APP_NODE_ENV} </span>
                        )}
                    </div>
                    <div className="mt-2 mb-4">
                        <div className="text-white text-900 text-3xl font-bold mb-2">{brand.appTitle}</div>
                        <div className="text-white-alpha-70 text-600 font-medium">{brand.subTitle}</div>
                        <div className="text-white-alpha-70 text-600 font-medium">Management System</div>
                    </div>
                    <div className="flex flex-column">
                        <span className="p-input-icon-left w-full mb-4">
                            <i className="pi pi-user"></i>
                            <InputText
                                id="loginId"
                                type="text"
                                className="w-full md:w-25rem login-input focus:login-input"
                                placeholder="ID"
                                value={loginId}
                                onChange={onChangeLoginId}
                                onKeyDown={(e) => onKeyDownCheckEnter(e, onClickLogin)}
                            />
                        </span>
                        <span className="p-input-icon-left w-full mb-4">
                            <i className="pi pi-lock"></i>
                            <InputText
                                id="pass"
                                type="password"
                                className="w-full md:w-25rem login-input"
                                placeholder="PW"
                                value={pass}
                                onChange={onChangePass}
                                onKeyDown={(e) => onKeyDownCheckEnter(e, onClickLogin)}
                            />
                        </span>
                        <div className="mb-4 flex flex-wrap gap-3">
                            <div className="login-check">
                                <Checkbox
                                    name="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.checked ?? false)}
                                    className="mr-2"
                                ></Checkbox>
                                <label htmlFor="checkbox" className="text-white-alpha-60 text-900 font-medium mr-8">
                                    Remember me
                                </label>
                            </div>
                            {/*<a className="text-white-alpha-60 text-600 cursor-pointer cursor-pointer ml-auto transition-colors transition-duration-300">*/}
                            {/*    ID / PW 찾기*/}
                            {/*</a>*/}
                        </div>
                        <div className="login-button">
                            <Button label="Log In" className="w-full te" onClick={onClickLogin}></Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login
